module.exports = __webpack_public_path__ + "static/media/gongcheng3.24d3bee1.png";